import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

export interface CanComponentDeactivate {
  isPromoCreationSuccess: boolean;
  canDeactivatePage: () => Promise<any>;
}

@Injectable()
export class CreatePromoSavedGuard implements CanDeactivate<CanComponentDeactivate> {
  canDeactivate(component: CanComponentDeactivate): boolean | Promise<any> {
    if (!component || component.isPromoCreationSuccess) {
      return true;
    }
    return component.canDeactivatePage();
  }
}
